$(document).ready(function() {

    var MoneyNoCents = {
        reverse: true,
        maxlength: false,
        placeholder: '0',
        onKeyPress: function(v, ev, curField, opts) {
                var mask = curField.data('mask').mask;
                var decimalSep = ',';
                if (curField.data('mask-isZero') && curField.data('mask-keycode') == 8)
                $(curField).val('');
            else if (v) {
                // remove previously added stuff at start of string
                v = v.replace(new RegExp('^0*\\'+decimalSep), '');
                $(curField).val(v).data('mask-isZero', (v=='0'));
            }
        }
    };

    var MoneyCents = {
      reverse: true,
      maxlength: false,
      placeholder: '0.00',
      onKeyPress: function(v, ev, curField, opts) {
        var mask = curField.data('mask').mask;
        var decimalSep = (/0(.)00/gi).exec(mask)[1] || ',';
        if (curField.data('mask-isZero') && curField.data('mask-keycode') == 8)
          $(curField).val('');
        else if (v) {
          // remove previously added stuff at start of string
          v = v.replace(new RegExp('^0*\\'+decimalSep+'?0*'), ''); //v = v.replace(/^0*,?0*/, '');
          v = v.length == 0 ? '0'+decimalSep+'00' : (v.length == 1 ? '0'+decimalSep+'0'+v : (v.length == 2 ? '0'+decimalSep+v : v));
          $(curField).val(v).data('mask-isZero', (v=='0'+decimalSep+'00'));
        }
      }
    };
    
    $('.input-number').mask("#,##0,000", MoneyNoCents);
    $('.input-number-cents').mask("#,##0.00", MoneyCents);
});

// import IMask from 'imask';
// const SimpleMaskMoney = require('simple-mask-money');

// // Default configuration
// var maskOptions = {
//     mask: Number,  // enable number mask
//     scale: 0,  // digits after point, 0 for integers
//     signed: false,  // disallow negative
//     thousandsSeparator: ',',  // any single char
//     padFractionalZeros: false,  // if true, then pads zeros at end to the length of scale
//     normalizeZeros: true,  // appends or removes zeros at ends
//     radix: '.',  // fractional delimiter
//     mapToRadix: [','],  // symbols to process as radix
// };
  
// //WITH CENTS
// const argsCents = {
//     allowNegative: false,
//     negativeSignAfter: false,
//     prefix: '',
//     suffix: '',
//     fixed: true,
//     fractionDigits: 2,
//     decimalSeparator: '.',
//     thousandsSeparator: ',',
//     cursor: 'move'
// };

// // Select the element
// var mumbersCollection = document.getElementsByClassName("input-number");
// var numbers = Array.from(mumbersCollection);

// numbers.forEach(function(numbers) {
//     const input = IMask(numbers, maskOptions);
// });

// // //NUMBERS WITH CENTS
// var centsNumbersCollection = document.getElementsByClassName("input-number-cents");
// var centsNumbers = Array.from(centsNumbersCollection);

// centsNumbers.forEach(function(centsNumbers) {
//     const inputCents = SimpleMaskMoney.setMask(centsNumbers, argsCents);
// });